/* eslint-disable @typescript-eslint/naming-convention */
import React from 'react'
import styled from '@emotion/styled'
import { colors } from '@resiliatech/birdsong'

const LOCAL_HOSTNAME = 'localhost'
const STAGING_HOSTNAME = 'staging-app.resilia.com'
const PROD_HOSTNAME = 'app.resilia.com'

export const envMap: Record<string, Record<string, string>> = {
  [LOCAL_HOSTNAME]: {
    backgroundColor: colors.accent.lightGreen,
    color: 'white',
    label: 'Development',
  },
  [STAGING_HOSTNAME]: {
    backgroundColor: 'yellow',
    color: 'black',
    label: 'Staging',
  },
  [PROD_HOSTNAME]: {
    backgroundColor: 'red',
    color: 'white',
    label: 'Production',
  },
}

const RibbonContainer = styled.div<{
  backgroundColor?: string
  color?: string
}>`
  background-color: ${({ backgroundColor }) =>
    backgroundColor || colors.error.light};
  color: ${({ color }) => color || colors.copy.headerLight};
  font-size: 18px;
  font-weight: bold;
  line-height: 1.8;
  position: fixed;
  padding-inline: 1lh;
  padding-bottom: var(0.5em);
  right: 0;
  text-transform: uppercase;
  top: 0;
  transform: translate(calc((1 - cos(45deg)) * 100%), -100%) rotate(45deg);
  transform-origin: 0 100%;
  z-index: 1000;
`

export const Ribbon = () => {
  const { hostname } = window.location
  const envOptions = envMap?.[hostname] || envMap[PROD_HOSTNAME]
  const { backgroundColor, color, label } = envOptions

  return (
    <RibbonContainer backgroundColor={backgroundColor} color={color}>
      {label}
    </RibbonContainer>
  )
}
